import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI'
import SuTransactionListUI from '../../../components/superUser/transaction/SuTransactionListUI'
import SuTransactionHeaderUI from '../../../components/superUser/transaction/SuTransactionHeaderUI'
import TransactionNavUI from '../../../components/superUser/transaction/TransactionNavUI'

const SuTransactionListPageUI = ({ context, account, errorList, txnList, filteredTxnList,
  searchFilter, onRefreshClick, onSearchFilterChange, bankAccountList,
  onCopyToClipboard, copyToClipboardText, details, onDetailsClick,
  hasMore, onMoreTransactions, gettingMore, bankAccountNumber,
  period, onPeriodChange, periodList, year, onYearChange, yearList,
  nachFileUploadMode, onNachFileUploadClick, onNachFileUploadCancel, onNachFileUpload, nachFileUploadErrorList,
  uploadTraditionalEscrowMode, onUploadTraditionalEscrowClick, onCancelTraditionalEscrowClick, uploadTraditionalEscrowErrorList,
  onTraditionalEscrowUpload,
  transactionTypeUpdated, onTransactionTypeUpdateClick, onTransactionTypeCancelClick, selectedTransactionId,
  downloadMode, onDownloadClick, onDownloadCancel,
  currentPage,pageSize,totalCount,
  onNextPage, onPreviousPage,
}) =>
  // <SuperUserAccountPageUI context={context} className='pg_su_txns' backLink='/su/accounts'
  //   headerText={`${account ? account.accountName : ''}`} dimension='w768'
  //   centered={!account || !txnList} account={account} bankAccountNumber={bankAccountNumber} page='txns'
  // >
  <SuperUserAccountPageUI context={context} className='pg_su_txns' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`} dimension='w768'
    centered={!account || !txnList} account={account} bankAccountNumber={bankAccountNumber} page='txns'
  >
    {
      (!account || !txnList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      bankAccountList && txnList &&
      <SuTransactionHeaderUI context={context} account={account} bankAccountList={bankAccountList}
        bankAccountNumber={bankAccountNumber} onRefreshClick={onRefreshClick}
        searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
        yearList={yearList} year={year} onYearChange={onYearChange}
        periodList={periodList} period={period} onPeriodChange={onPeriodChange}
        downloadMode={downloadMode} onDownloadClick={onDownloadClick} onDownloadCancel={onDownloadCancel}
      />
    }
    {
      txnList && txnList.length === 0 &&
      <EmptyListUI
        context={context}
        createDisabledMessageLabel='No transactions'
      />
    }

    {
      txnList && filteredTxnList && txnList.length !== 0 &&
      // <SuTransactionListUI
      //   context={context}
      //   txnList={getPaginatedTransactions()} // use sliced data
      //   hasMore={currentPage * pageSize < filteredTxnList.length} // compute from client
      //   onMoreTransactions={this.goToNextPage} // next page handler
      //   gettingMore={gettingMore}
      //   bankAccountNumber={bankAccountNumber}
      //   onCopyToClipboard={onCopyToClipboard}
      //   copyToClipboardText={copyToClipboardText}
      //   onRefreshClick={onRefreshClick}
      //   //
      //   onUploadTraditionalEscrowClick={onUploadTraditionalEscrowClick}
      //   uploadTraditionalEscrowErrorList={uploadTraditionalEscrowErrorList}
      //   //
      //   details={details}
      //   onDetailsClick={onDetailsClick}
      //   //
      //   onNachFileUploadClick={onNachFileUploadClick}
      //   nachFileUploadErrorList={nachFileUploadErrorList}
      //   //
      //   transactionTypeUpdated={transactionTypeUpdated}
      //   onTransactionTypeUpdateClick={onTransactionTypeUpdateClick}
      //   onTransactionTypeCancelClick={onTransactionTypeCancelClick}
      //   selectedTransactionId={selectedTransactionId}
      // />
      <>
        <SuTransactionListUI
          context={context}
          txnList={txnList}
          account={account}
          bankAccountNumber={bankAccountNumber}
          onRefreshClick={onRefreshClick}
          details={details}
          onDetailsClick={onDetailsClick}
          onCopyToClipboard={onCopyToClipboard}
          copyToClipboardText={copyToClipboardText}
          onNachFileUploadClick={onNachFileUploadClick}
          nachFileUploadErrorList={nachFileUploadErrorList}
          onUploadTraditionalEscrowClick={onUploadTraditionalEscrowClick}
          uploadTraditionalEscrowErrorList={uploadTraditionalEscrowErrorList}
          transactionTypeUpdated={transactionTypeUpdated}
          onTransactionTypeUpdateClick={onTransactionTypeUpdateClick}
          onTransactionTypeCancelClick={onTransactionTypeCancelClick}
          selectedTransactionId={selectedTransactionId}

          // Pagination props
          currentPage={currentPage}
          pageSize={pageSize}
          filteredTxnListLength={filteredTxnList ? filteredTxnList.length : 0}
          onNextPage={onNextPage}
          onPreviousPage={onPreviousPage}
        />
        <div className="pagination-controls" style={{ textAlign: 'center', margin: '20px 0' }}>
          <button onClick={onPreviousPage} disabled={currentPage === 1}>Previous</button>
          <span style={{ margin: '0 10px' }}>
            Page {currentPage} of {Math.ceil(filteredTxnList.length / pageSize)}
          </span>
          <button onClick={onNextPage} disabled={!hasMore}>Next</button>
        </div>
      </>

    }

    <FileUploadModalSF
      context={context}
      uploadMode={nachFileUploadMode}
      onCancelClick={onNachFileUploadCancel}
      signedUrlApi={`/api/su/files/fileUploadSignedUrl`}
      onUpload={onNachFileUpload}

    />
    {
      account &&
      <FileUploadModalSF
        context={context}
        uploadMode={uploadTraditionalEscrowMode}
        onCancelClick={onCancelTraditionalEscrowClick}
        signedUrlApi={`/api/su/accounts/${account.accountId}/escrowAccounts/${bankAccountNumber}/fileUploadSignedUrl`}
        onUpload={onTraditionalEscrowUpload}
      />
    }

  </SuperUserAccountPageUI>

export default SuTransactionListPageUI
